export default __webpack_public_path__ + "static/media/Background 5_00016.9642e589.png";